module.exports = __webpack_public_path__ + "static/img/icon tj pdf.13732f14.svg";